import { capitalizeLocation } from '@zoocasa/node-kit/strings/capitalize';
import SearchPrediction from 'data/search-predictions';

const PROVINCE_LABELS = ['province', 'state'];
const POSTAL_CODE_LABELS = ['postal code', 'zip'];

export const isProvinceLabel = (label: string) => {
  return PROVINCE_LABELS.includes(label);
};

export const isPostalCodeLabel = (label: string) => {
  return POSTAL_CODE_LABELS.includes(label);
};

export const getLastSearchDescription = (lastSearchLocation: SearchPrediction) => {
  return isProvinceLabel(lastSearchLocation.label) ? capitalizeLocation(lastSearchLocation.description).replace('-', ' ') : capitalizeLocation(lastSearchLocation.description);
};

